import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { Product } from '../models/product.model';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class ProductService {

  constructor(public db: AngularFirestore , public authService : AuthService) { }

  // tslint:disable-next-line: one-line
  addProduct(product){
   let newProduct  = JSON.stringify(product);
   newProduct = JSON.parse(newProduct);
    return this.db.collection('products').add(Object.assign({}, newProduct));
  }

  // tslint:disable-next-line: one-line
  editProduct(product){
// tslint:disable-next-line: comment-format
//edit Products

return this.db.collection('products').doc(product.productId).update(product);
  }
  inactiveProduct(product){
    // tslint:disable-next-line: comment-format
    //edit Products
    return this.db.collection('products').doc(product.productId).update({active : !product.active})
      }

  // tslint:disable-next-line: one-line
  getAllProducts(){
    // tslint:disable-next-line: comment-format
    //geting all products
    return this.db.collection('products').get().pipe(
      map(action => action.docs.map(res => {
        const data = res.data();
        const productId = res.id;
        return {productId, ...data};
      })),
    );
  }
  getAllProductOffers(productCode,){
    // tslint:disable-next-line: comment-format
    //geting all products
    if(this.authService.isRetailer == true){
    return this.db.collection('product-offer',ref=>ref.where("retailer", "==", true ).where("productCode","==",productCode)).valueChanges()
  }else{
    return this.db.collection('product-offer',ref=>ref.where("distributor", "==", true ).where("productCode","==",productCode)).valueChanges()
 
  }
}
// tslint:disable-next-line: one-line
getProductByID(Id){
  return this.db.collection('products').doc(Id).get().pipe(
    map(res => {
      const data = res.data();
      return data;
    }));
}

getProductByCategory(categoryId){
 return this.db.collection('products' , ref => ref .where("categoryId", "==", categoryId)).valueChanges();
}
}
